// The current local day, re-rendering at midnight so a calendar left open
// overnight moves its "today" highlight instead of staying on yesterday.

import { useEffect, useState } from 'react'
import { addDays, startOfDay } from 'date-fns'

export function useToday(): Date {
  const [today, setToday] = useState(() => startOfDay(new Date()))

  useEffect(() => {
    const msUntilMidnight = addDays(today, 1).getTime() - Date.now()
    const timer = setTimeout(
      () => setToday(startOfDay(new Date())),
      Math.max(msUntilMidnight, 0) + 1000,
    )
    return () => clearTimeout(timer)
  }, [today])

  return today
}
